var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystoreBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 40,
    viewBox: "0 0 136 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_253)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.952 40H5.95606C3.19934 40 0.954224 37.7456 0.954224 35V5C0.954224 2.24439 3.19934 0 5.95606 0H130.952C133.707 0 135.954 2.24439 135.954 5V35C135.954 37.7456 133.707 40 130.952 40Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.952 0.800499C133.265 0.800499 135.157 2.68828 135.157 5V35C135.157 37.3117 133.277 39.1995 130.952 39.1995H5.95606C3.64389 39.1995 1.75144 37.3117 1.75144 35V5C1.75144 2.68828 3.63147 0.800499 5.95606 0.800499H130.952ZM130.952 0H5.95606C3.19934 0 0.954224 2.25436 0.954224 5V35C0.954224 37.7556 3.19934 40 5.95606 40H130.952C133.707 40 135.954 37.7556 135.954 35V5C135.954 2.25436 133.707 0 130.952 0Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0726 13.2319C71.1711 13.2319 70.4111 12.9152 69.8101 12.2917C69.214 11.6857 68.8812 10.8503 68.8961 9.99745C68.8961 9.08723 69.2041 8.31666 69.8101 7.70568C70.4086 7.08224 71.1686 6.76553 72.0701 6.76553C72.9617 6.76553 73.7216 7.08224 74.3326 7.70568C74.9386 8.33661 75.2465 9.10718 75.2465 9.99745C75.2366 10.9102 74.9286 11.6807 74.3326 12.2892C73.7341 12.9177 72.9741 13.2319 72.0726 13.2319ZM45.2481 13.2319C44.3664 13.2319 43.6015 12.9201 42.9757 12.3042C42.3548 11.6907 42.0394 10.9152 42.0394 9.99995C42.0394 9.08474 42.3548 8.30917 42.9757 7.69571C43.5891 7.07975 44.354 6.76803 45.2481 6.76803C45.6852 6.76803 46.1099 6.85531 46.5172 7.03237C46.917 7.20444 47.2423 7.43885 47.4832 7.72563L47.5428 7.79795L46.8698 8.46129L46.8003 8.379C46.4203 7.92513 45.9112 7.70319 45.2381 7.70319C44.6371 7.70319 44.1131 7.91765 43.681 8.34159C43.2464 8.76803 43.0253 9.32663 43.0253 10.0024C43.0253 10.6783 43.2464 11.2369 43.681 11.6633C44.1131 12.0872 44.6371 12.3017 45.2381 12.3017C45.8789 12.3017 46.4178 12.0872 46.8375 11.6633C47.0859 11.4139 47.2399 11.0648 47.2945 10.6234H45.1363V9.69072H48.2208L48.2333 9.77551C48.2556 9.93262 48.278 10.0947 48.278 10.2443C48.278 11.1047 48.0197 11.8004 47.5081 12.3142C46.9269 12.9226 46.167 13.2319 45.2481 13.2319ZM80.9139 13.0997H79.9627L77.0495 8.4189L77.0744 9.26179V13.0972H76.1232V6.9002H77.2085L77.2383 6.94758L79.9776 11.3566L79.9528 10.5162V6.9002H80.9139V13.0997ZM64.925 13.0997H63.9614V7.83287H62.29V6.9002H66.5939V7.83287H64.9225V13.0997H64.925ZM61.5052 13.0997H60.5441V6.9002H61.5052V13.0997ZM56.1035 13.0997H55.1424V7.83287H53.471V6.9002H57.7749V7.83287H56.1035V13.0997ZM52.8625 13.0897H49.177V6.9002H52.8625V7.83287H50.1406V9.53361H52.5968V10.4563H50.1406V12.1571H52.8625V13.0897ZM70.5154 11.6508C70.9451 12.0822 71.4666 12.2992 72.0726 12.2992C72.6959 12.2992 73.2051 12.0872 73.6297 11.6508C74.0519 11.2269 74.2655 10.6708 74.2655 9.99995C74.2655 9.32912 74.0519 8.77052 73.6322 8.34907C73.2026 7.91765 72.6786 7.7007 72.0751 7.7007C71.4517 7.7007 70.9426 7.91267 70.5204 8.34907C70.0982 8.77301 69.8846 9.32912 69.8846 9.99995C69.8846 10.6708 70.0957 11.2294 70.5154 11.6508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8068 21.7556C66.4598 21.7556 64.5575 23.5436 64.5575 26.01C64.5575 28.4539 66.4723 30.2643 68.8068 30.2643C71.1537 30.2643 73.0561 28.4638 73.0561 26.01C73.0561 23.5436 71.1537 21.7556 68.8068 21.7556ZM68.8068 28.5786C67.5228 28.5786 66.4176 27.5112 66.4176 26C66.4176 24.4663 67.5253 23.4215 68.8068 23.4215C70.0908 23.4215 71.196 24.4663 71.196 26C71.1984 27.5212 70.0908 28.5786 68.8068 28.5786ZM59.5357 21.7556C57.1888 21.7556 55.2864 23.5436 55.2864 26.01C55.2864 28.4539 57.2012 30.2643 59.5357 30.2643C61.8827 30.2643 63.7851 28.4638 63.7851 26.01C63.7851 23.5436 61.8802 21.7556 59.5357 21.7556ZM59.5357 28.5786C58.2518 28.5786 57.1466 27.5112 57.1466 26C57.1466 24.4663 58.2542 23.4215 59.5357 23.4215C60.8197 23.4215 61.9249 24.4663 61.9249 26C61.9249 27.5212 60.8197 28.5786 59.5357 28.5786ZM48.5039 23.0549V24.8554H52.8078C52.6762 25.8653 52.3434 26.611 51.8343 27.1222C51.2035 27.7556 50.2299 28.4439 48.5138 28.4439C45.8688 28.4439 43.8 26.2993 43.8 23.6434C43.8 20.9875 45.8688 18.8429 48.5138 18.8429C49.9418 18.8429 50.9824 19.409 51.7548 20.1322L53.0264 18.8554C51.9535 17.8229 50.5255 17.0324 48.5237 17.0324C44.8953 17.0324 41.8505 20 41.8505 23.6334C41.8505 27.2768 44.8928 30.2344 48.5237 30.2344C50.4832 30.2344 51.9535 29.591 53.1158 28.3791C54.3004 27.1895 54.6755 25.5112 54.6755 24.1571C54.6755 23.7357 54.6432 23.3566 54.5761 23.0349H48.5014C48.5039 23.0324 48.5039 23.0549 48.5039 23.0549ZM93.6273 24.4564C93.2721 23.5013 92.1992 21.7456 89.9988 21.7456C87.8183 21.7456 86.0053 23.4688 86.0053 26C86.0053 28.389 87.7984 30.2544 90.2099 30.2544C92.1471 30.2544 93.2746 29.0648 93.739 28.3666L92.3011 27.399C91.8242 28.1097 91.1611 28.5761 90.2199 28.5761C89.2687 28.5761 88.6031 28.1421 88.161 27.2868L93.826 24.9302C93.826 24.9327 93.6273 24.4564 93.6273 24.4564ZM87.8506 25.8778C87.8059 24.2344 89.1221 23.399 90.0634 23.399C90.806 23.399 91.4244 23.7656 91.6355 24.2993L87.8506 25.8778ZM83.2486 30H85.1087V17.5013H83.2486V30ZM80.1938 22.7008H80.1268C79.707 22.1995 78.9098 21.7456 77.8916 21.7456C75.7781 21.7456 73.831 23.6135 73.831 26.0125C73.831 28.4015 75.7681 30.2469 77.8916 30.2469C78.8974 30.2469 79.707 29.7905 80.1268 29.2793H80.1938V29.8903C80.1938 31.5137 79.3295 32.389 77.9363 32.389C76.7963 32.389 76.0885 31.5661 75.8004 30.8778L74.1837 31.5561C74.6481 32.6783 75.8874 34.0673 77.9338 34.0673C80.1143 34.0673 81.9621 32.7781 81.9621 29.6334V22H80.2037V22.7008C80.2062 22.7008 80.1938 22.7008 80.1938 22.7008ZM78.058 28.5786C76.774 28.5786 75.7011 27.5013 75.7011 26.0125C75.7011 24.5112 76.774 23.4239 78.058 23.4239C79.3295 23.4239 80.3155 24.5237 80.3155 26.0125C80.3279 27.5013 79.332 28.5786 78.058 28.5786ZM102.337 17.5013H97.889V30H99.7492V25.2668H102.34C104.398 25.2668 106.422 23.7681 106.422 21.389C106.422 19.01 104.406 17.5013 102.337 17.5013ZM102.392 23.5212H99.7467V19.2319H102.392C103.785 19.2319 104.572 20.3865 104.572 21.3766C104.572 22.3566 103.775 23.5212 102.392 23.5212ZM113.878 21.7332C112.527 21.7332 111.134 22.3342 110.558 23.6434L112.207 24.3317C112.562 23.6434 113.212 23.409 113.9 23.409C114.864 23.409 115.838 23.9875 115.86 25.02V25.1521C115.527 24.9626 114.797 24.6733 113.923 24.6733C112.142 24.6733 110.337 25.6509 110.337 27.4838C110.337 29.1621 111.797 30.2394 113.424 30.2394C114.673 30.2394 115.361 29.6733 115.79 29.0175H115.857V29.985H117.651V25.197C117.651 22.9676 116.001 21.7332 113.878 21.7332ZM113.645 28.5786C113.036 28.5786 112.184 28.2793 112.184 27.5112C112.184 26.5436 113.247 26.1771 114.154 26.1771C114.973 26.1771 115.361 26.3541 115.847 26.5985C115.713 27.7207 114.77 28.5686 113.645 28.5786ZM124.192 22L122.056 27.4215H121.989L119.776 22H117.775L121.095 29.5786L119.203 33.7905H121.14L126.249 22H124.192ZM107.448 30H109.308V17.5013H107.448V30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3454 7.53364C11.0573 7.84536 10.8909 8.32167 10.8909 8.94511V31.0573C10.8909 31.6808 11.0573 32.1571 11.3553 32.4563L11.4323 32.5237L23.7705 20.1346V19.8578L11.4223 7.46631L11.3454 7.53364Z",
    fill: "url(#paint0_linear_6_253)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8757 24.2768L23.7604 20.1446V19.8554L27.8757 15.7232L27.9651 15.7781L32.8328 18.5561C34.2261 19.3441 34.2261 20.6459 32.8328 21.4439L27.9651 24.2219L27.8757 24.2768Z",
    fill: "url(#paint1_linear_6_253)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9651 24.2219L23.7605 20L11.3453 32.4663C11.7998 32.9551 12.5622 33.01 13.4141 32.5337L27.9651 24.2219Z",
    fill: "url(#paint2_linear_6_253)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9651 15.7781L13.4141 7.4788C12.5622 6.99002 11.7973 7.05735 11.3453 7.54613L23.7605 20L27.9651 15.7781Z",
    fill: "url(#paint3_linear_6_253)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8757 24.1322L13.424 32.3766C12.6168 32.8429 11.8966 32.8105 11.4322 32.3866L11.3552 32.4639L11.4322 32.5312C11.8966 32.9527 12.6168 32.9876 13.424 32.5212L27.9751 24.222L27.8757 24.1322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8329 21.2993L27.8633 24.1322L27.9527 24.2219L32.8205 21.4439C33.5183 21.0449 33.8611 20.5212 33.8611 20C33.8189 20.4788 33.4637 20.9327 32.8329 21.2993Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4141 7.62348L32.8329 18.7008C33.4637 19.0574 33.8189 19.5237 33.8735 20C33.8735 19.4788 33.5308 18.9551 32.8329 18.5561L13.4141 7.47884C12.0209 6.67834 10.8909 7.34667 10.8909 8.94517V9.08981C10.8909 7.48881 12.0209 6.83295 13.4141 7.62348Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_253",
    x1: 22.6638,
    y1: 8.70654,
    x2: 2.88936,
    y2: 13.9538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_253",
    x1: 34.6498,
    y1: 20,
    x2: 10.5521,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_253",
    x1: 25.6788,
    y1: 22.2973,
    x2: 9.71601,
    y2: 49.0538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_253",
    x1: 8.21899,
    y1: 0.17879,
    x2: 15.3407,
    y2: 12.1287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    fill: "white",
    transform: "translate(0.954224)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreBadge);
export default __webpack_public_path__ + "static/media/playstore-badge.6f8d21d72542bf825b10fe847d9e302a.svg";
export { ForwardRef as ReactComponent };